// Per spec/design-system.md §Primitive 5. richText variant trusts the
// `HtmlString` brand on `text`: html kernel escapes plain strings on
// interpolation and passes HtmlString through un-escaped (D-021 + D-022).

import { html } from '../render'
import { tokens } from '../tokens'
import { HtmlString } from '../types'

export type TextAlign = 'left' | 'center' | 'right'
export type TextTransform = 'none' | 'uppercase'

export interface TextProps {
  text: string | HtmlString
  size?: number
  weight?: number
  color?: string
  align?: TextAlign
  lineHeight?: number
  tracking?: string
  inline?: boolean
  transform?: TextTransform
}

export function text({
  text,
  size = tokens.type.size.base,
  weight = tokens.type.weight.regular,
  color = tokens.color['text-primary'],
  align = 'left',
  lineHeight = tokens.type.leading.normal,
  tracking = tokens.type.tracking.normal,
  inline = false,
  transform = 'none',
}: TextProps): HtmlString {
  const margin = inline ? '' : 'margin: 0; '
  const letterSpacing =
    tracking !== tokens.type.tracking.normal ? ` letter-spacing: ${tracking};` : ''
  const textTransform = transform !== 'none' ? ` text-transform: ${transform};` : ''
  const style = `${margin}font-family: ${tokens.type.fontFamily}; font-size: ${size}px; font-weight: ${weight}; line-height: ${lineHeight}; color: ${color}; text-align: ${align};${letterSpacing}${textTransform}`
  // prettier-ignore
  return inline
    ? html`<span style="${style}">${text}</span>`
    : html`<p style="${style}">${text}</p>`
}
